import {useNavigate} from 'react-router-dom'
import { GridActionsCellItem } from '@mui/x-data-grid';

function EditWorkDayActionItem({ id, ...props }) {
    const navigate = useNavigate();

    return (
        <>
            <GridActionsCellItem {...props} onClick={() => { navigate(`/timekeeper/${id}`)}} />
        </>
    )
}

export default EditWorkDayActionItem
